import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-stripe-verification',
  template: '',
})
export class StripeVerificationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
